import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import moment from 'moment';

import ThemeContext from '../contexts/themeContext';

import { getItem, setItem } from '../lib/localstorage';
import showNotification from '../components/extras/showNotification';
import Icon from '../components/icon/Icon';


const LANG_KEY = 'i18nextLng';
const LANGUAGE_LIST = {
	en: {
		text: 'English',
		lng: 'en',
		icon: 'CustomUsa',
	},
	ko: {
		text: '한국어',
		lng: 'ko',
		icon: 'CustomKor',
	},
    vi: {
  		text: 'Tiếng việt',
  		lng: 'vi',
  		icon: 'CustomVi',
  	},
    ch: {
        text: '中文',
        lng: 'ch',
        icon: 'CustomChina',
    },

};

export const getCurrentLang = () => getItem(LANG_KEY) ? getItem(LANG_KEY) : 'ko';
export const setCurrentLang = (lang) => setItem(LANG_KEY, lang);

export const getLangWithKey = (key) =>
	LANGUAGE_LIST[key];

export const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const { setLang } = useContext(ThemeContext);

  const updateLanguage = async (lang) => {
    i18n.services.resourceStore.data = {};
    await i18n.changeLanguage(lang);
    moment.locale(lang);
    setLang(lang);
    setCurrentLang(lang);

    showNotification(
      <span className='d-flex align-items-center'>
        <Icon icon={getLangWithKey(lang)?.icon} size='lg' className='me-1' />
        <span>{`${getLangWithKey(lang)?.text}`}</span>
      </span>,
      t('language.updatedLanguage'),
    );

  }

  return { updateLanguage };
}